/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BulkChallengeAudit
 */
export interface BulkChallengeAudit {
  /**
   *
   * @type {string}
   * @memberof BulkChallengeAudit
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof BulkChallengeAudit
   */
  carrierInvoiceId: string;
}

/**
 * Check if a given object implements the BulkChallengeAudit interface.
 */
export function instanceOfBulkChallengeAudit(
  value: object,
): value is BulkChallengeAudit {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("carrierInvoiceId" in value) || value["carrierInvoiceId"] === undefined)
    return false;
  return true;
}

export function BulkChallengeAuditFromJSON(json: any): BulkChallengeAudit {
  return BulkChallengeAuditFromJSONTyped(json, false);
}

export function BulkChallengeAuditFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BulkChallengeAudit {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    carrierInvoiceId: json["carrierInvoiceId"],
  };
}

export function BulkChallengeAuditToJSON(json: any): BulkChallengeAudit {
  return BulkChallengeAuditToJSONTyped(json, false);
}

export function BulkChallengeAuditToJSONTyped(
  value?: BulkChallengeAudit | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    carrierInvoiceId: value["carrierInvoiceId"],
  };
}
